import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { DashboardSectionHeader } from "../DashboardSectionHeader"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { faHandshake } from "@fortawesome/pro-solid-svg-icons"
import { CheckInForm } from "../checkInModal/CheckInForm"
import { CheckInAlerts } from "../checkInModal/CheckInAlerts"
import { useCheckInAlerts } from "../checkInModal/useCheckInAlerts"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import React from "react"

const useStyles = makeStyles()(() => ({
    card: {
        padding: ".5rem",
        borderRadius: ".75rem !important",
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.08)",
        "&::before": {
            display: "none",
        },
    },
    accordionDetails: {
        padding: ".75rem 1rem 1.75rem 1rem",
    },
    accordionSummary: {
        margin: ".25rem 0",
    },
}))

export function GuestCheckInSection() {
    const { classes } = useStyles()
    const alertsApi = useCheckInAlerts()

    return (
        <Stack>
            <CheckInAlerts alerts={alertsApi.alerts} onRemove={alertsApi.removeAlert} />
            <Accordion disableGutters defaultExpanded elevation={0} className={classes.card}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                    <DashboardSectionHeader icon={faHandshake}>
                        <LocalizedStrict id="service-center-reports-dashboard-guest-check-in-title">
                            <Typography variant="h6" fontWeight="bold">
                                Guest check-in
                            </Typography>
                        </LocalizedStrict>
                    </DashboardSectionHeader>
                </AccordionSummary>
                <AccordionDetails className={classes.accordionDetails}>
                    <CheckInForm variant="block" alertsApi={alertsApi} />
                </AccordionDetails>
            </Accordion>
        </Stack>
    )
}
